import React, {Component} from 'react'

class BackToTop extends Component {
    state = {
        showScroll: false
    }

    componentDidMount() {
        window.addEventListener('scroll', this._checkScrollTop)
    }

    _checkScrollTop = () => {
        const {showScroll} = this.state

        if (!showScroll && window.pageYOffset > 800) {
            this.setState({
                showScroll: true
            })
        } else if (showScroll && window.pageYOffset <= 800) {
            this.setState({
                showScroll: false
            })
        }
    }

    _backToTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    render() {
        const {showScroll} = this.state

        return (
            <div className="BackToTop" style={{display: showScroll ? 'block' : 'none'}} onClick={this._backToTop}>
                <i className='fa fa-long-arrow-up'/>
            </div>
        )
    }
}

export default BackToTop